export const shippingQuoteConfig = {
  ShippingQuoteForm: {
    title: 'New Quote.',
    fields: ['provider', 'deliveryTime', 'cost', 'discount'],
  },
  fields: {
    provider: {
      label: 'Shipping Provider',
      placeholder: 'Enter Provider',
      component: 'forms.TextField',
      shouldRenderFieldLabel: false,
    },
    deliveryTime: {
      label: 'Shipping Time (business days)',
      placeholder: 'e.g. 5',
      component: 'forms.TextField',
      fieldStore: 'forms.IntegerFieldStore',
      minVal: 1,
      maxVal: 1000,
      suffixValue: ' business days', //
      shouldRenderFieldLabel: false,
    },
    cost: {
      label: 'Shipping Cost',
      placeholder: '00.00',
      component: 'forms.DecimalField',
      optional: true,
      shouldRenderFieldLabel: false,
    },
    discount: {
      label: 'Discount',
      placeholder: '5 %',
      component: 'forms.TextField',
      fieldStore: 'forms.IntegerFieldStore',
      suffixValue: ' %',
      minVal: 0,
      maxVal: 100,
      shouldRenderFieldLabel: false,
    },
  },
};
